/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {WinterHoard} from "../WinterHoard";

export class ReelStart implements GameRoundPresentation {
    private readonly _reelId:number;
    stagger?:number;
    abortStagger?:number;

    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public getAnimation(data:SpinParsedGameData):Timeline | null {
        return WinterHoard.timelineReelsController.startSpin(this._reelId);
    }

}